import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { Tooltip } from '@instinet-analytics/core-lib';
import {
    getProfileGridBoxText,
    getProfileTooltip,
} from 'widgets/estimatedTradeCost/components/options';

export default function profileCellRenderer({ data }: ICellRendererParams) {
    const profile: string = data.profile;

    return (
        <Tooltip text={getProfileTooltip(profile)} showDelay={0}>
            <div className="profile">{getProfileGridBoxText(profile)}</div>
        </Tooltip>
    );
}
